module.exports = __webpack_public_path__ + "static/media/21ECLAC6.33a58669.jpg";